import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const SelectionHelperText = styled(Typography)({
  fontSize: '14px',
  lineHeight: '22px',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  color: 'text.secondary',
});

export default SelectionHelperText;
